<template>
  <div class="card ">
    <div class="rule-title">
      {{ ruleData.buy_rule_title }}
    </div>
    <div class="rule-content" v-html="ruleData.buy_rule_content"></div>
  </div>
</template>

<script>
import {fetchRule} from "@/api/merchant-registration";

export default {
  name: "arrow-order-rule",
  data() {
    return {
      ruleData: {
        buy_rule_content: '',
        buy_rule_title: '',
      }
    }
  },
  mounted() {
    this._fetchData();
  },
  methods: {
    _fetchData() {
      fetchRule().then(resp => {
        this.ruleData = resp
      })
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  background: #FFFFFF;
  box-shadow: 0px 0px 28px 0px rgba(217, 217, 217, 0.19);
  border-radius: 13px;
  padding: 24px;
  min-height: 90vh;
}

.rule-title {
  font-size: 16px;
  font-weight: 500;
  color: #E41919;
  padding-bottom: 15px;
}

.rule-content {
  font-size: 13px;
  color: #333;
  white-space: pre-wrap;
  line-height: 30px;
}

</style>
